import { render, staticRenderFns } from "./TrafficPackages.vue?vue&type=template&id=2d7ec64f&scoped=true&"
import script from "./TrafficPackages.vue?vue&type=script&lang=js&"
export * from "./TrafficPackages.vue?vue&type=script&lang=js&"
import style0 from "./TrafficPackages.vue?vue&type=style&index=0&id=2d7ec64f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ec64f",
  null
  
)

export default component.exports